import collapsible from '../../modules/module--collapsible';

export default function() {
    collapsible.add({
        block: '.menu-main__dropdown',
        elToggle: '.menu-main__dropdown-toggle',
        elContent: '.menu-main__dropdown-content',
        closeOutside: false,
        closeAny: false,
        closeOthers: false,
        breakpoint: 'laptop',
        callbackOpenAfter() {
            $('body')
                .addClass('noscroll')
                .addClass('z-index-change');
        },
        callbackCloseAfter() {
            $('body')
                .removeClass('noscroll')
                .removeClass('z-index-change');
        },
        debug: false
    });
}
